import React from 'react';
import './Team.css';

const members = [
  {
    id: 'm1',
    name: 'Monuar Hossain',
    role: 'Co-founder',
    img: '/team/riaz.jpg',
    desc: 'Oversees business development and operations. Skilled in software architecture.',
  },
  {
    id: 'm6',
    name: 'Juthi Akter',
    role: 'Co-founder',
    img: '/team/juthi.jpg',
    desc: 'Manages client relations and project delivery. Experienced in business management and marketing.',
  },
  {
    id: 'm2',
    name: 'MD. Sakiul Hasan Sifat',
    role: 'Engineering Lead',
    img: '/team/sifat.jpg',
    desc: 'Leads product development and design. Passionate about user experience.',
  },
  {
    id: 'm3',
    name: 'Soisob Islam',
    role: 'Web Dev Lead',
    img: '/team/soisob.jpg',
    desc: 'Heads the web development team with expertise in frontend and backend technologies.',
  },
  {
    id: 'm4',
    name: 'Shamiul Alim Badhon',
    role: 'Marketing Lead',
    img: '/team/badhon.jpg',
    desc: 'Drives brand strategy and user engagement initiatives.',
  },
  // {
  //   id: 'm5',
  //   name: 'Shamiul Alim Badhon',
  //   role: 'Marketing Lead',
  //   img: '/team/badhon.jpg',
  //   desc: 'Drives brand strategy and user engagement initiatives.',
  // },
];

export default function Team() {
  return (
    <section id="team" className="comp-section team">
      <div className="team-head">
        <h2>Team</h2>
        <p className="muted">Small, senior engineering teams that move fast.</p>
      </div>

      <div className="team-grid">
        {members.map((m) => (
          <article key={m.id} className="member-card">
            <div className="member-media">
              <img src={m.img} alt={`${m.name}`} loading="lazy" />
            </div>
            <div className="member-body">
              <div className="member-name">{m.name}</div>
              <div className="member-role">{m.role}</div>
              <p className="member-desc">{m.desc}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
